/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placedetailcopylink3Inputs */

const en_placedetailcopylink3 = /** @type {(inputs: Placedetailcopylink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

const de_placedetailcopylink3 = /** @type {(inputs: Placedetailcopylink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopieren`)
};

/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Placedetailcopylink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placedetailcopylink3 = /** @type {((inputs?: Placedetailcopylink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placedetailcopylink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placedetailcopylink3(inputs)
	return de_placedetailcopylink3(inputs)
});
export { placedetailcopylink3 as "placeDetailCopyLink" }